var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-md-8"},[_c('div',{staticClass:"card mt-2rem"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"ft-1rem mb-0"},[_vm._v("Página não encontrada")]),_vm._v(" "),_c('span',[_vm._v("Erro 404")])])])])])])
}]

export { render, staticRenderFns }